// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1WrnG","label":"LabeledBox_label__3JBxR"};